import { Box, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import BgLineLeft from '../assets/head-line-left.png';
import BgHorizontalSeparator from '../assets/head-horizontal-separator.png';
import FUserActivationActivate from '../features/user-activation/FUserActivationActivate';
import FUserActivationPresentation from '../features/user-activation/FUserActivationPresentation';
import AppLangSelect from '../../../app/features/lang/features/select/AppLangSelect';
import queryString from 'query-string';
import { useAppLang } from '../../../app/features/lang/providers/AppLangProvider';
import AppLoaderPage from '../../../app/features/loader/page/AppLoaderPage';
import AppError404 from '../../../app/features/error/404/AppError404';
import isBase64 from '../../../app/utils/isBase64';

const PAuthInvestorUserActivationLanding = () => {
	const { language, changeLanguage } = useAppLang();

	const [emailActivation, setEmailActivation] = useState<string | null>(null);
	const [defaultLanguage, setDefaultLanguage] = useState<string | (string | null)[] | null>(null);

	const [userExistSuccess, setUserExistSuccess] = useState<boolean | null>(null);

	useEffect(() => {
		const getParams = queryString.parse(location.search);
		if (getParams && getParams['lang']) {
			setDefaultLanguage(getParams['lang']);
		}
		if (getParams && getParams['email']) {
			if (isBase64(getParams['email'])) {
				setEmailActivation(atob(getParams['email'].toString()));
				// No account status lookup: any well-formed link shows the page (ITP-11640).
				setUserExistSuccess(true);
			} else {
				setUserExistSuccess(false);
			}
		}
	}, []);

	useEffect(() => {
		if (language && defaultLanguage) {
			if (language !== defaultLanguage) {
				changeLanguage(defaultLanguage as string);
			}
			setDefaultLanguage(null);
		}
	}, [language, defaultLanguage, changeLanguage]);

	return (
		<>
			{userExistSuccess ? (
				<Box
					style={{
						backgroundColor: '#1A2B48',

						width: '100%',
						minHeight: '100vh',
						padding: '0px',
						position: 'relative',
					}}
				>
					<Box sx={{ position: 'absolute', right: '10px', top: '10px' }}>
						<AppLangSelect style={{ color: '#FFF' }} />
					</Box>
					<Box
						sx={{
							backgroundImage: { sm: `url(${BgLineLeft})`, xs: '' },
							backgroundSize: 'auto 100%',
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center left',
							width: '100%',
							minHeight: '100vh',
							padding: '0px',
						}}
					>
						<Box
							style={{
								width: '100%',
								height: '45%',
								minHeight: '45vh',
							}}
						>
							<Container maxWidth="lg">
								<FUserActivationActivate emailActivation={emailActivation ?? ''} />
							</Container>
						</Box>

						<Box
							style={{
								backgroundImage: `url(${BgHorizontalSeparator})`,
								backgroundSize: '100% 100%',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center center',
								width: '100%',
								height: '55%',
								minHeight: '55vh',
							}}
						>
							<Container maxWidth="xl">
								<FUserActivationPresentation />
							</Container>
						</Box>
					</Box>
				</Box>
			) : userExistSuccess === false ? (
				<AppError404 />
			) : (
				<AppLoaderPage />
			)}
		</>
	);
};

export default PAuthInvestorUserActivationLanding;
